import RestClient from './../../service/rest-client';
import AccountViewTypeEnum from './AccountViewTypeEnum';
import {Signal} from 'signals';
import moment from 'moment';

class Service {

    event = {
        onAccountsWithoutSendShipment: new Signal(),
        onAccountsWithoutReceivePackage: new Signal(),
        onAccountsSortBySendShipments: new Signal(),
        onAccountsSortByRevenue: new Signal(),
        onInactiveAccountsForTimePeriod: new Signal(),
        onShipmentsWithCoupons: new Signal(),
        onSentShipmentsByMonth: new Signal()
    };
    // start accounts without sent shipment code
    fetchCannedAccountReport(page, searchParams, viewType) {
        page = page || 1;
        var limit = 10, pageSize = 10,
            offset = (page - 1) * pageSize;

        RestClient.isSessionActive();
        var queryParams = [`offset=${ offset }`, `limit=${ limit }`];

        if (searchParams.createdDateStart) {
            queryParams.push(`created_date_start=${ searchParams.createdDateStart }`)
        }

        if (searchParams.createdDateEnd) {
            queryParams.push(`created_date_end=${ searchParams.createdDateEnd }`)
        }

        if (searchParams.shipDateStart) {
            queryParams.push(`date_start=${ searchParams.shipDateStart }`)
        }

        if (searchParams.shipDateEnd) {
            queryParams.push(`date_end=${ searchParams.shipDateEnd }`)
        }

        if (searchParams.intervalOfDays) {
            queryParams.push(`interval_days=${ searchParams.intervalOfDays }`)
        }

        if (searchParams.countryCode) {
            queryParams.push(`country_code=${ searchParams.countryCode }`)
        }

        var urlRequestEndPointString = "";

        if (viewType === AccountViewTypeEnum.AccountWithoutSentShipment) {
            urlRequestEndPointString = "/reporting/cannedreport/accountwithoutsentshipment" + "?";
        } else if (viewType === AccountViewTypeEnum.AccountWithoutReceivedPackage) {
            urlRequestEndPointString = "/reporting/cannedreport/accountwithoutreceivedpackage" + "?";
        } else if (viewType === AccountViewTypeEnum.AccountSortBySentShipments) {
            urlRequestEndPointString = "/reporting/cannedreport/accountsortbysentshipments" + "?";
        } else if (viewType === AccountViewTypeEnum.AccountSortByRevenue) {
            urlRequestEndPointString = "/reporting/cannedreport/accountsortbyrevenue" + "?";
        } else if (viewType === AccountViewTypeEnum.InactiveAccountForTimePeriod) {
            urlRequestEndPointString = "/reporting/cannedreport/inactiveaccountsfortimeperiod" + "?";
        } else if (viewType === AccountViewTypeEnum.ShipmentsWithCoupons) {
            urlRequestEndPointString = "/reporting/cannedreport/shipmentswithcoupons" + "?";
        } else if (viewType === AccountViewTypeEnum.SentShipmentsByMonth) {
            urlRequestEndPointString = "/reporting/cannedreport/sent-shipments-by-month" + "?";
        }

        var urlRequestTemplate = urlRequestEndPointString + queryParams.join("&");

        return RestClient.getRequest(urlRequestTemplate,"").then((data) => {
            var page = data.page_number;
            var pageSize = data.page_size,
                offset = (page - 1) * pageSize;
            var pagingMetadata = {
                page: data.page_number,
                startIndex: offset + 1,
                endIndex: offset + pageSize,
                totalCount: data.total_count,
                pageCount: Math.max(Math.ceil(data.total_count / pageSize), 1)//Always 1 page, even if 0 results
            };
            data.pagingMetadata = pagingMetadata;

            if (viewType === AccountViewTypeEnum.AccountWithoutSentShipment) {
                data.results = this.parseResultData(data.results, viewType);
                this.event.onAccountsWithoutSendShipment.dispatch(data);
            } else if (viewType === AccountViewTypeEnum.AccountWithoutReceivedPackage) {
                data.results = this.parseResultData(data.results, viewType);
                this.event.onAccountsWithoutReceivePackage.dispatch(data);
            } else if (viewType === AccountViewTypeEnum.AccountSortBySentShipments) {
                data.results = this.parseResultData(data.results, viewType);
                this.event.onAccountsSortBySendShipments.dispatch(data);
            } else if (viewType === AccountViewTypeEnum.AccountSortByRevenue) {
                data.results = this.parseResultData(data.results, viewType);
                this.event.onAccountsSortByRevenue.dispatch(data);
            } else if (viewType === AccountViewTypeEnum.InactiveAccountForTimePeriod) {
                data.results = this.parseResultData(data.results, viewType);
                this.event.onInactiveAccountsForTimePeriod.dispatch(data);
            } else if (viewType === AccountViewTypeEnum.ShipmentsWithCoupons) {
                data.results = this.parseResultData(data.results, viewType);
                this.event.onShipmentsWithCoupons.dispatch(data);
            } else if (viewType === AccountViewTypeEnum.SentShipmentsByMonth) {
                data.results = this.parseResultData(data.results, viewType);
                this.event.onSentShipmentsByMonth.dispatch(data);
            }

        }).catch((error) => {
            console.log("Error: " + error);
        });
    }

    parseResultData(resultData, viewType) {
        var parsedArray = resultData.map(function(dataItem) {
            var parsedObject = dataItem;

            if (viewType === AccountViewTypeEnum.AccountWithoutSentShipment) {
                parsedObject.createdDate = moment(dataItem.createdDate).format("L");
            } else if (viewType === AccountViewTypeEnum.AccountWithoutReceivedPackage) {
                parsedObject.createdDate = moment(dataItem.createdDate).format("L");
            } else if (viewType === AccountViewTypeEnum.AccountSortBySentShipments) {
                parsedObject.createdDate = moment(dataItem.createdDate).format("L");
            } else if (viewType === AccountViewTypeEnum.AccountSortByRevenue) {
                parsedObject.createdDate = moment(dataItem.createdDate).format("L");
            } else if (viewType === AccountViewTypeEnum.InactiveAccountForTimePeriod) {
                parsedObject.createdDate = moment(dataItem.createdDate).format("L");
                parsedObject.lastShipmentDate = moment(dataItem.lastShipmentDate).format("L");
            } else if (viewType === AccountViewTypeEnum.ShipmentsWithCoupons) {
                parsedObject.createdDate = moment(dataItem.createdDate).format("L");
            } else if (viewType === AccountViewTypeEnum.SentShipmentsByMonth) {
                parsedObject.createdDate = moment(dataItem.createdDate).format("L");
            }

            return parsedObject;
        });
        return parsedArray;
    }

    downloadCannedAccountReport(searchParams, viewType) {
        RestClient.isSessionActive();
        var queryParams = [];

        if (searchParams.createdDateStart) {
            queryParams.push(`created_date_start=${ searchParams.createdDateStart }`)
        }

        if (searchParams.createdDateEnd) {
            queryParams.push(`created_date_end=${ searchParams.createdDateEnd }`)
        }

        if (searchParams.shipDateStart) {
            queryParams.push(`date_start=${ searchParams.shipDateStart }`)
        }

        if (searchParams.shipDateEnd) {
            queryParams.push(`date_end=${ searchParams.shipDateEnd }`)
        }

        if (searchParams.intervalOfDays) {
            queryParams.push(`interval_days=${ searchParams.intervalOfDays }`)
        }

        if (searchParams.countryCode) {
            queryParams.push(`country_code=${ searchParams.countryCode }`)
        }

        var urlRequestTemplate = "";
        var urlRequestEndPointString = "";

        if (viewType === AccountViewTypeEnum.AccountWithoutSentShipment) {
            urlRequestEndPointString = "/reporting/cannedreport/accountwithoutsentshipment/file";
        } else if (viewType === AccountViewTypeEnum.AccountWithoutReceivedPackage) {
            urlRequestEndPointString = "/reporting/cannedreport/accountwithoutreceivedpackage/file";
        } else if (viewType === AccountViewTypeEnum.AccountSortBySentShipments) {
            urlRequestEndPointString = "/reporting/cannedreport/accountsortbysentshipments/file";
        } else if (viewType === AccountViewTypeEnum.AccountSortByRevenue) {
            urlRequestEndPointString = "/reporting/cannedreport/accountsortbyrevenue/file";
        } else if (viewType === AccountViewTypeEnum.InactiveAccountForTimePeriod) {
            urlRequestEndPointString = "/reporting/cannedreport/inactiveaccountsfortimeperiod/file";
        } else if (viewType === AccountViewTypeEnum.ShipmentsWithCoupons) {
            urlRequestEndPointString = "/reporting/cannedreport/shipmentswithcoupons/file";
        } else if (viewType === AccountViewTypeEnum.SentShipmentsByMonth) {
            urlRequestEndPointString = "/reporting/cannedreport/sentshipmentsbymonth/file";
        }

        if (queryParams.length > 0) {
            urlRequestTemplate = urlRequestEndPointString + "?" + queryParams.join("&");
            RestClient.downloadFile(urlRequestTemplate, true);
        } else {
            urlRequestTemplate = urlRequestEndPointString;
            RestClient.downloadFile(urlRequestTemplate, false);
        }
    }

} export default new Service();